<template>
    <div 
        class="logo-container"
        :style="{
            '--desktop-width': width || '330px',
            '--mobile-width': widthMobile || '142px',
            '--desktop-height': height || '60px',
            '--mobile-height': heightMobile || '42px'
        }"
    >
        <MiscLink
            aria-current="page"
            to="/"
            aria-label="Startseite"
            class="flex items-center h-full max-w-full logo-link w-max">
            <!-- Desktop Logo-->
            <MiscImage
                v-if="media?.image"
                :lazy-load="false"
                :preload="true"
                :loading="true"
                :src="media.image.url"
                :alt="media.image.translated?.alt ? media.image.translated?.alt : ''"
                :title="media.image.translated?.title"
                class="hidden lg:block object-contain shrink-0 max-w-full"
                :style="`width: ${width || '330px'}; height: ${height || '60px'};`"
                :width="width || '330px'"
                :height="height || '60px'"
            />
            <!-- Mobile Logo-->
            <MiscImage
                v-if="media?.image2"
                :lazy-load="false"
                :preload="true"
                :loading="true"
                :src="media.image2.url"
                :alt="media.image2.translated?.alt ? media.image2.translated?.alt : ''"
                :title="media.image2.translated?.title"
                :width="widthMobile || '142px'"
                :height="heightMobile || '42px'"
                class="block lg:hidden object-contain shrink-0 max-w-full"
                :style="`width: ${widthMobile || '142px'}; height: ${heightMobile || '42px'};`"
            />
        </MiscLink>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    media: any
    width?: string
    widthMobile?: string
    height?: string
    heightMobile?: string
}>()
</script>

<style scoped>
.logo-container {
    width: var(--mobile-width);
    height: var(--mobile-height);
}

@media (min-width: 1024px) {
    .logo-container {
        width: var(--desktop-width);
        height: var(--desktop-height);
    }
}
</style>